let apiBase = '';

export function setApiBase(url: string) {
  apiBase = url;
}

export function getApiBase(): string {
  return apiBase;
}
